import Axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const BASIC_AUTH = process.env.REACT_APP_BASIC_AUTH;
Axios.defaults.baseURL = API_URL;

export class HttpService {
  _axios = Axios.create();

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  get = async (url) => await this.request(this.getOptionsConfig("get", url));

  post = async (url, data) => await this.request(this.getOptionsConfig("post", url, data));

  postLogin = async (url, data) => await this.request(this.getLoginConfig("post", url, data));

  postRegister = async (url, data) => await this.request(this.getRegisterConfig("post", url, data));

  postPublic = async (url, data) => await this.request(this.getPublicConfig("post", url, data));

  put = async (url, data) => await this.request(this.getOptionsConfig("put", url, data));
  
  putPublic = async (url, data) => await this.request(this.getPublicConfig("put", url, data));

  patch = async (url, data) => await this.request(this.getOptionsConfig("patch", url, data));

  delete = async (url) => await this.request(this.getOptionsConfig("delete", url));

  getOptionsConfig = (method, url, data) => {
    return {
      method,
      url,
      data,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    };
  };

  getLoginConfig = (method, url, data) => {
    const urlEncodedData = new URLSearchParams(data).toString();
    return {
      method,
      url,
      data: urlEncodedData,
      headers: {
        "Authorization": `Basic ${BASIC_AUTH}`,
        "Content-Type": "application/x-www-form-urlencoded"
      },
    };
  };

  getRegisterConfig = (method, url, data) => {
    return {
      method,
      url,
      data,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    };
  };

  getPublicConfig = (method, url, data) => {
    return {
      method,
      url,
      data,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then((res) => resolve(res.data))
        .catch((ex) => reject(ex.response.data));
    });
  }
}

export default new HttpService();
